import React from "react";
import "./ECommerce.css";
import "../Page.css";
import axios from "axios";
import { calculateCartTotal, security_key, Url } from "../../Services/Api";
import CustomBtn from "../../Components/UI-Controls/Buttons/Btn";
import CustomBtnLogo from "../../Components/UI-Controls/Buttons/BtnLogo";
import actionIcon from "../../Assets/Images/ActionBtn 30 x 30.png";
import { IoIosMail } from "react-icons/io";
import { BiSolidMessageRoundedCheck } from "react-icons/bi";
import {
    Accordion,
    AccordionItem,
    AccordionItemHeading,
    AccordionItemButton,
    AccordionItemPanel,
} from "react-accessible-accordion";
import "react-accessible-accordion/dist/fancy-example.css";
import DataTable from "react-data-table-component";
import { useState, useEffect } from "react";
// import MainLoader from "../../Components/UI-Controls/MainLoader/MainLoader";
import { format, formatDistanceToNow, isYesterday, parseISO } from "date-fns";
import { toZonedTime } from "date-fns-tz";
import { formatDate } from "../../Components/UI-Controls/DateFormat/DateFormat1";
import LastActiveTimestamp from "../../Components/UI-Controls/DateFormat/LastActive";
import ShimmerLoader from "../../Components/UI-Controls/Loader/ShimmerLoader";
import Pagination from "../../Components/UI-Controls/Pagination/PaginationRashid";
import InputField from "../../Components/UI-Controls/InputField/InputField";
import { IoEyeOutline } from "react-icons/io5";
import { RiDeleteBin6Line } from "react-icons/ri";
import { FiEdit } from "react-icons/fi";
import BottomToust from "../../Components/BottomToust/BottomToust";
import LastActivityTimestamp from "../../Components/UI-Controls/DateFormat/LastActivity";
import ElipticalPagenation from "../../Components/UI-Controls/Pagination/Pagination2";
import { useNavigate, useLocation } from "react-router-dom";
import Dropdowncustom from "../../Components/UI-Controls/Dropdown/dropdownaddgeneral1";
import csv from "../../Assets/csv.png"

const CartAbdList = () => {
    const rowsPerPage = 10;
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [openDropdownId, setOpenDropdownId] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [filtersApplied, setFiltersApplied] = useState(false);
    const [filterLoading, setFilterLoading] = useState(false);
    const [custName, setCustName] = useState("");
    const [email, setEmail] = useState("");
    const [phoneNo, setPhoneNo] = useState("");
    const [selectedStatus, setSelectedStatus] = useState("");
    const [filtersModified, setFiltersModified] = useState(false);
    const [filteredData, setFilteredData] = useState(data);
    const [selectedRows, setSelectedRows] = useState([]);
    const [showMessage, setShowMessage] = useState(false);
    const [toastMessage, setToastMessage] = useState("");
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    const location = useLocation();

    const [paginationData, setPaginationData] = useState({
        totalItems: 0,
        currentPage: 1,
        totalPages: 1,
        pageSize: 10,
        hasNextPage: false,
        hasPrevPage: false,
    });


    const OrderStatusOptions = [
        { value: "new", label: "New" },
        { value: "inprogress", label: "In Progress" },
        { value: "sold", label: "Sold" },
        { value: "archive", label: "Archive" }
    ];


    const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 1500);

    useEffect(() => {
        const handleResize = () => {
            setIsSmallScreen(window.innerWidth <= 1500);
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);



    useEffect(() => {
        fetchTableData();
    }, []);

    const handleExportCSV = async () => {
        try {
            setLoading(true);
            const token = sessionStorage.getItem('authToken');
            const headers = {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
                'x-api-key': security_key
            };

            // ✅ Fetch all data without pagination
            const response = await axios.get(`${Url}/api/v1/unused-cart/get-abd`, {
                headers,
                params: {
                    page: 1,
                    limit: 10000, // a large limit to fetch all data
                    custName,
                    email,
                    phoneNo,
                    ordStatus: selectedStatus
                }
            });

            const allData = response.data.data;

            if (!allData || allData.length === 0) {
                setToastMessage("No data available to export!");
                setShowMessage(true);
                return;
            }

            // ✅ Convert data to CSV format
            const csvHeader = [
                "Customer Name",
                "Email",
                "Phone",
                "State",
                "City",
                "Total",
                "Products",
                "Status",
                "Last Activity"
            ];

            const csvRows = allData.map(item => [
                `${item.checkout?.first_name || ""} ${item.checkout?.last_name || ""}`,
                item.checkout?.email || "",
                item.checkout?.phone || "",
                item.checkout?.state || "",
                item.checkout?.city || "",
                `$${calculateCartTotal(item.cart)}`,
                item.cart?.products?.length || 0,
                item.cart?.status || "",
                formatDate(item.cart?.updatedAt).toString()
            ]);

            // Combine header and rows
            const csvContent = [
                csvHeader.join(","),
                ...csvRows.map(row => row.map(value => `"${value}"`).join(","))
            ].join("\n");

            // ✅ Create Blob and trigger download
            const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
            const link = document.createElement("a");
            const url = URL.createObjectURL(blob);
            link.href = url;
            link.setAttribute("download", "AbandonedCarts.csv");
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            setToastMessage("CSV exported successfully!");
            setShowMessage(true);
        } catch (error) {
            console.error("Error exporting CSV:", error);
            setToastMessage("Failed to export CSV");
            setShowMessage(true);
        } finally {
            setLoading(false);
        }
    };


    const timeZone = "America/New_York";

    // async function fetchTableData(page = 1, pageSize = 10) {
    //     setLoading(true);
    //     setError(null);
    //     try {
    //         const URL = `${Url}/api/v1/unused-cart/get-abd?page=${page}&limit=${pageSize}`;
    //         const token = sessionStorage.getItem('authToken');
    //         const headers = {
    //             "Content-Type": "application/json",
    //             Authorization: `Bearer ${token}`,
    //             'x-api-key': security_key
    //         };

    //         const response = await axios.get(URL, { headers });
    //         const responseData = response.data;

    //         setData(responseData.data); // your current page's data
    //         setFilteredData(responseData.data); // update filtered as well
    //         setPaginationData(responseData.pagination); // we'll create this in step 2

    //         setToastMessage("Cart Abandoned Data fetched successfully!");
    //         setShowMessage(true);
    //     } catch (error) {
    //         const errMsg = error?.response?.data?.message || error.message;
    //         setError(errMsg);
    //         setToastMessage(`Failed to fetch data: ${errMsg}`);
    //         setShowMessage(true);
    //     } finally {
    //         setLoading(false);
    //     }
    // }
    async function fetchTableData(page = 1, pageSize = 10, appliedFilters = {}) {
        setLoading(true);
        setError(null);
        try {
            const params = {
                page,
                limit: pageSize,
                custName: appliedFilters.custName || "",
                email: appliedFilters.email || "",
                phoneNo: appliedFilters.phoneNo || "",
                ordStatus: appliedFilters.ordStatus || ""
            };

            const URL = `${Url}/api/v1/unused-cart/get-abd`;
            const token = sessionStorage.getItem('authToken');
            const headers = {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
                'x-api-key': security_key
            };

            const response = await axios.get(URL, { headers, params });
            const responseData = response.data;

            setData(responseData.data);
            setFilteredData(responseData.data);
            setPaginationData(responseData.pagination);

            setToastMessage("Cart Abandoned Data fetched successfully!");
            setShowMessage(true);
        } catch (error) {
            const errMsg = error?.response?.data?.message || error.message;
            setError(errMsg);
            setToastMessage(`Failed to fetch data: ${errMsg}`);
            setShowMessage(true);
        } finally {
            setLoading(false);
        }
    }



    const customStyles = {
        headCells: {
            style: {
                height: "clamp(50px, 5vw, 56px)",
                background: "transparent",
                opacity: "1",
                textAlign: "center",
                justifyContent: "center",
                border: "none",
                color: "var(--text-color-1)",
                fontFamily: "var(--font-family)",
                fontWeight: "var(--font-weight-medium)",
                fontSize: "clamp(var(--font-size-medium), 0.8vw, calc(var(--font-size-medium) + 2px))",
            },
        },
        cells: {
            style: {
                height: "clamp(50px, 6vw, 66px)",
                justifyContent: "center",
                textAlign: "center",
                background: "transparent",
                borderTop: "var(--standered-border)",
                borderRight: "none",
                color: "var(--text-color-1)",
                fontFamily: "var(--font-family)",
                fontWeight: "var(--font-weight-regular)",
                fontSize: "clamp(var(--font-size-small), 0.8vw, calc(var(--font-size-small) + 2px))",
            },
        },
    };

    const toggleDropdown = (id) => {
        setOpenDropdownId((prevId) => (prevId === id ? null : id));
    };

    const handleView = (row) => {
        // Extract the first part of the pathname (e.g. '/Cart/...', '/E-Commerce/...')
        const centralRouteName = location.pathname.split("/")[1];

        if (centralRouteName === "Cart") {
            navigate(`/Cart/cart-abandoned/${row._id}`, { state: row });
        } else {
            navigate(`/E-Commerce/cart-abandoned/${row._id}`, { state: row });
        }
    };


    const handleAction = (action, row) => {
        console.log(`Action: ${action} triggered for row:`, row);
        switch (action) {
            // case "view":
            //     handleView(row);
            //     break;
            case "edit":
                handleView(row);
                break;
            // case "delete":
            //     setOpenDropdownId(null);
            //     break;
            default:
                break;
        }
    };

    const handleClickOutside = (event) => {
        if (
            !event.target.closest(".dropdown-menu") &&
            !event.target.closest(".bar-icon")
        ) {
            setOpenDropdownId(null);
        }
    };

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const handleCloseMessageModal = () => {
        setShowMessage(false);
    };

    useEffect(() => {
        if (showMessage === true) {
            const timeOut = setTimeout(() => {
                setShowMessage(false);
            }, 3000);

            return () => clearTimeout(timeOut);
        }
    }, [showMessage]);

    const CustomerColumns = [
        {
            name: (
                <input
                    type="checkbox"
                    style={{ margin: 0 }}
                    onChange={(e) => handleSelectAll(e.target.checked)}
                    checked={selectedRows.length === data.length && data.length > 0}
                />
            ),
            cell: (row) =>
                loading ? (
                    <ShimmerLoader width="20px" height="20px" />
                ) : (
                    <input
                        type="checkbox"
                        style={{ margin: 0 }}
                        onChange={() => handleRowSelect(row._id)}
                        checked={selectedRows.includes(row._id)}
                    />
                ),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
            width: "50px",
        },
        {
            name: "Customer",
            cell: (row) =>
                loading ? (
                    <ShimmerLoader width="200px" height="22.5px" borderRadius="20px" />
                ) : (
                    <div>
                        <div>
                            {row?.checkout?.first_name} {row?.checkout?.last_name}
                        </div>{" "}
                        <div style={{ fontSize: "0.9em", color: "#666" }}>
                            {row?.checkout?.email}
                        </div>{" "}
                    </div>
                ),
            minWidth: "280px",
            maxWidth: "350px",
        },
        {
            name: "Phone",
            selector: (row) =>
                loading ? (
                    <ShimmerLoader width="90px" height="22.5px" borderRadius="20px" />
                ) : (
                    <div>
                        {row?.checkout?.phone}
                    </div>
                ),
            minWidth: "125px",
            maxWidth: "155px",
        },
        {
            name: "Location",
            selector: (row) =>
                loading ? (
                    <ShimmerLoader width="90px" height="22.5px" borderRadius="20px" />
                ) : (
                    <div>
                        <div>
                            {row?.checkout?.state}
                        </div>{" "}
                        <div style={{ fontSize: "0.9em", color: "#666" }}>
                            {row?.checkout?.city}
                        </div>{" "}
                    </div>
                ),
            minWidth: "125px",
            maxWidth: "155px",
        },
        {
            name: "Total",
            selector: (row) => {
                if (loading) {
                    return <ShimmerLoader width="120px" height="22.5px" borderRadius="20px" />;
                }
                else {
                    return <div>${calculateCartTotal(row?.cart)}</div>
                }
            },
            minWidth: "80px",
            maxWidth: "100px",
            omit: isSmallScreen,
        },
        {
            name: "Products",
            selector: (row) =>
                loading ? (
                    <ShimmerLoader width="90px" height="22.5px" borderRadius="20px" />
                ) : row.cart?.products ? (
                    row.cart?.products?.length
                ) : (
                    0
                ),
            minWidth: "80px",
            maxWidth: "100px",
            omit: isSmallScreen,
        },
        {
            name: "Last Activity",
            selector: (row) => row?.cart?.updatedAt,
            minWidth: "200px",
            maxWidth: "220px",
            cell: (row) => {
                if (loading) {
                    return <ShimmerLoader width="120px" height="22.5px" borderRadius="20px" />;
                }

                if (row?.cart?.updatedAt) {
                    const lastLoginAt = formatDate(row?.cart?.updatedAt);
                    const now = new Date();
                    let displayText;

                    if (isYesterday(lastLoginAt)) {
                        displayText = `Yesterday, ${format(lastLoginAt, "h:mm a")}`;
                    } else if (now - lastLoginAt < 24 * 60 * 60 * 1000) {
                        displayText = formatDistanceToNow(lastLoginAt, { addSuffix: true });
                    } else {
                        displayText = <LastActivityTimestamp createdAt={row?.cart?.updatedAt} />;
                    }

                    return (
                        <div style={{
                            whiteSpace: "normal",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            display: "-webkit-box",
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: "vertical",
                            maxHeight: "44px",
                        }}>
                            {displayText}
                        </div>
                    );
                }

                return "No data";
            },
        },

        // {
        //     name: "Status",
        //     wrap: true,
        //     cell: (row) => {
        //         if (loading) {
        //             return (
        //                 <ShimmerLoader width="90px" height="22.5px" borderRadius="20px" />
        //             );
        //         }
        //         let textColor;
        //         let backgroundColor;
        //         let stockLabel;
        //         switch (row?.cart?.status) {
        //             case "inprogress":
        //                 textColor = "#3A7D99";
        //                 backgroundColor = "#3A7D9910";
        //                 stockLabel = "In Progress";
        //                 break;
        //             case "new":
        //                 textColor = "#B45A67";
        //                 backgroundColor = "#B45A6710";
        //                 stockLabel = "New";
        //                 break;
        //             case "cancelled":
        //                 textColor = "#B45A67";
        //                 backgroundColor = "#B45A6710";
        //                 stockLabel = "Canceled";
        //                 break;
        //             case "failed":
        //                 textColor = "#A33D4A";
        //                 backgroundColor = "#A33D4A10";
        //                 stockLabel = "Failed";
        //                 break;
        //             case "pending":
        //                 textColor = "#F4B074";
        //                 backgroundColor = "#F4B07410";
        //                 stockLabel = "Pending";
        //                 break;
        //             case "on-hold":
        //                 textColor = "#6C757D";
        //                 backgroundColor = "#6C757D10";
        //                 stockLabel = "On Hold";
        //                 break;
        //             case "archive":
        //                 textColor = "#835D97";
        //                 backgroundColor = "#835D9720";
        //                 stockLabel = "Archive";
        //                 break;
        //             case "processing":
        //                 textColor = "#F4B074";
        //                 backgroundColor = "#F4B07410";
        //                 stockLabel = "Processing";
        //                 break;
        //             case "sold":
        //                 textColor = "#4F8057";
        //                 backgroundColor = "#4F805710";
        //                 stockLabel = "Sold";
        //                 break;
        //             case "completed":
        //                 textColor = "#4F8057";
        //                 backgroundColor = "#4F805710";
        //                 stockLabel = "Completed";
        //                 break;
        //             case "approved":
        //                 textColor = "#28A745";        // Green text
        //                 backgroundColor = "#28A74510"; // Light green background (10% opacity)
        //                 stockLabel = "Approved";
        //                 break;
        //             default:
        //                 textColor = "#999";
        //                 backgroundColor = "#E0E0E010";
        //                 stockLabel = "Unknown";
        //         }
        //         return (
        //             <div
        //                 style={{
        //                     color: textColor,
        //                     backgroundColor: backgroundColor,
        //                     padding: "5px 10px",
        //                     borderRadius: "5px",
        //                     display: "inline-block",
        //                     fontWeight: 600,
        //                     whiteSpace: "normal",
        //                     overflow: "hidden",
        //                     textOverflow: "ellipsis",
        //                     display: "flex",
        //                     flexWrap: "wrap",
        //                     gap: "4px",
        //                     maxWidth: "100%",
        //                 }}
        //             >
        //                 {stockLabel}
        //             </div>
        //         );
        //     },
        //     minWidth: "140px",
        //     maxWidth: "160px",
        // },

        {
            name: "Status",
            wrap: true,
            cell: (row) => {
                if (loading) {
                    return (
                        <ShimmerLoader width="90px" height="22.5px" borderRadius="20px" />
                    );
                }

                let textColor;
                let backgroundColor;
                let stockLabel;

                switch (row?.cart?.status) {
                    case "inprogress":
                        textColor = "#3A7D99";
                        backgroundColor = "#3A7D9910";
                        stockLabel = "In Progress";
                        break;
                    case "new":
                        textColor = "#B45A67";
                        backgroundColor = "#B45A6710";
                        stockLabel = "New";
                        break;
                    case "cancelled":
                        textColor = "#B45A67";
                        backgroundColor = "#B45A6710";
                        stockLabel = "Canceled";
                        break;
                    case "failed":
                        textColor = "#A33D4A";
                        backgroundColor = "#A33D4A10";
                        stockLabel = "Failed";
                        break;
                    case "pending":
                        textColor = "#F4B074";
                        backgroundColor = "#F4B07410";
                        stockLabel = "Pending";
                        break;
                    case "on-hold":
                        textColor = "#6C757D";
                        backgroundColor = "#6C757D10";
                        stockLabel = "On Hold";
                        break;
                    case "archive":
                        textColor = "#835D97";
                        backgroundColor = "#835D9720";
                        stockLabel = "Archive";
                        break;
                    case "processing":
                        textColor = "#F4B074";
                        backgroundColor = "#F4B07410";
                        stockLabel = "Processing";
                        break;
                    case "sold":
                        textColor = "#4F8057";
                        backgroundColor = "#4F805710";
                        stockLabel = "Sold";
                        break;
                    case "completed":
                        textColor = "#4F8057";
                        backgroundColor = "#4F805710";
                        stockLabel = "Completed";
                        break;
                    case "approved":
                        textColor = "#28A745";
                        backgroundColor = "#28A74510";
                        stockLabel = "Approved";
                        break;
                    default:
                        textColor = "#999";
                        backgroundColor = "#E0E0E010";
                        stockLabel = "Unknown";
                }

                // ✅ Check followups for emailSent or messageSent
                const hasEmailSent = row?.cart?.followups?.some(f => f.emailSent);
                const hasMessageSent = row?.cart?.followups?.some(f => f.messageSent);

                return (
                    <div>
                        <div className="tooltip_opts_ind_1">
                            {hasMessageSent && <BiSolidMessageRoundedCheck />}
                            {hasEmailSent && <IoIosMail />}
                        </div>
                        <div
                            style={{
                                color: textColor,
                                backgroundColor: backgroundColor,
                                padding: "5px 10px",
                                borderRadius: "5px",
                                display: "flex",
                                alignItems: "center",
                                gap: "6px",
                                fontWeight: 600,
                                maxWidth: "100%",
                                flexWrap: "wrap"
                            }}
                        >
                            {stockLabel}

                        </div>
                    </div>
                );
            },
            minWidth: "160px",
            maxWidth: "200px",
        },





        {
            name: "Action",
            cell: (row) =>
                loading ? (
                    <ShimmerLoader width="60px" height="22.5px" />
                ) : (
                    <div style={{ position: "relative" }}>
                        <img
                            src={actionIcon}
                            alt="Action Icon"
                            width="40"
                            height="40"
                            style={{ cursor: "pointer", margin: 0, padding: 0 }}
                            className={`bar-icon ${openDropdownId === row._id ? "rotated" : ""
                                }`}
                            onClick={() => toggleDropdown(row._id)}
                        />
                        {openDropdownId === row._id && (
                            <div className={`dropdown-menu show animate-dropdown-left`}>
                                <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                                    {/* <li
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            cursor: "pointer",
                                            padding: "5px 10px",
                                            border: "none",
                                        }}
                                        onClick={() => handleAction("view", row)}
                                    >
                                        <IoEyeOutline style={{ marginRight: "12px" }} className="icon-img-updated" />
                                        View
                                    </li> */}
                                    <li
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            cursor: "pointer",
                                            padding: "5px 10px",
                                            border: "none",
                                        }}
                                        onClick={() => handleAction("edit", row)}
                                    >
                                        <FiEdit style={{ marginRight: "12px" }} className="icon-img-updated" />
                                        Edit
                                    </li>
                                    {/* <li
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            cursor: "pointer",
                                            padding: "5px 10px",
                                            border: "none",
                                        }}
                                        onClick={() => handleAction("delete", row)}
                                    >
                                        <RiDeleteBin6Line style={{ marginRight: "12px" }} className="icon-img-updated" />
                                        Delete
                                    </li> */}
                                </ul>
                            </div>
                        )}
                    </div>
                ),
            minWidth: "100px",
            maxWidth: "105px",
        },
    ];

    // const handleFilters = () => {
    //     if (!custName && !email && !phoneNo) {
    //         let warningMessage = "Kindly select or enter respective filtration value...";
    //         setToastMessage(warningMessage);
    //         setShowMessage(true);
    //         return;
    //     }
    //     console.log("Selected Filters:", {
    //         custName,
    //         email,
    //         phoneNo,
    //         selectedStatus
    //     });

    //     // const filteredData = data.filter((item) => {
    //     //     const fullName = `${item.first_name || ""} ${item.last_name || ""}`
    //     //         .trim()
    //     //         .toLowerCase();

    //     //     const custNameMatch = custName
    //     //         ? fullName.includes(custName.toLowerCase())
    //     //         : true;

    //     //     const emailMatch = email ? item.email.toString().includes(email) : true;

    //     //     const phoneMatch = phoneNo ? item.email.toString().includes(email) : true;

    //     //     return custNameMatch && emailMatch && phoneMatch;
    //     // });

    //     setFilteredData(filteredData);
    //     setFiltersApplied(true);
    //     setFiltersModified(false);
    // };


    const handleFilters = () => {
        if (!custName && !email && !phoneNo && !selectedStatus) {
            setToastMessage("Kindly select or enter respective filtration value...");
            setShowMessage(true);
            return;
        }

        const appliedFilters = {
            custName,
            email,
            phoneNo,
            ordStatus: selectedStatus
        };

        fetchTableData(1, rowsPerPage, appliedFilters); // API call with filters
        setFiltersApplied(true);
        setFiltersModified(false);
    };

    useEffect(() => {
        if (filtersApplied && filtersModified) {
            handleFilters();
            setFiltersModified(false);
        }
    }, [custName, email, phoneNo, filtersApplied, filtersModified]);

    const handleFilterChange = (value, fieldName) => {
        if (fieldName === "custName") {
            setCustName(value);
        } else if (fieldName === "email") {
            setEmail(value);
        } else if (fieldName === "phoneNo") {
            setPhoneNo(value);
        } else if (fieldName === "ordStatus") {
            setSelectedStatus(value);
        }
        setFiltersModified(true);
    };



    const handleResetFilters = () => {
        setCustName("");
        setEmail("");
        setPhoneNo("");
        setSelectedStatus("");
        setFiltersApplied(false);
        setFiltersModified(false);
        fetchTableData();
    };

    const handleSelectAll = (isSelected) => {
        if (isSelected) {
            const allRowIds = data.map((row) => row._id);
            setSelectedRows(allRowIds);
        } else {
            setSelectedRows([]);
        }
    };

    const handleRowSelect = (rowId) => {
        setSelectedRows((prevSelected) => {
            if (prevSelected.includes(rowId)) {
                return prevSelected.filter((id) => id !== rowId);
            } else {
                return [...prevSelected, rowId];
            }
        });
    };

    const totalPages = paginationData.totalPages;

    const paginatedData = filteredData;


    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
        const appliedFilters = {
            custName,
            email,
            phoneNo,
            ordStatus: selectedStatus
        };
        fetchTableData(pageNumber, rowsPerPage, appliedFilters);
    };

    const handlePrevPage = () => {
        if (paginationData.hasPrevPage) {
            const prevPage = paginationData.currentPage - 1;
            setCurrentPage(prevPage);
            const appliedFilters = {
                custName,
                email,
                phoneNo,
                ordStatus: selectedStatus
            };
            fetchTableData(prevPage, rowsPerPage, appliedFilters);
        }
    };

    const handleNextPage = () => {
        if (paginationData.hasNextPage) {
            const nextPage = paginationData.currentPage + 1;
            setCurrentPage(nextPage);
            const appliedFilters = {
                custName,
                email,
                phoneNo,
                ordStatus: selectedStatus
            };
            fetchTableData(nextPage, rowsPerPage, appliedFilters);
        }
    };


    const placeholderRows = Array(7).fill({ uid: "", name: "", image: "" });

    const displayedData = loading ? placeholderRows : filteredData;


    return (
        <div className="AllOrderPage">
            <div className="sectionall_1_a">
                <div></div>
                <div
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        gap: "10px",
                        marginRight: "15px",
                    }}
                >

                    <CustomBtnLogo
                        image={csv}
                        label="Export CSV"
                        withIcon={true}
                        iconType="import"
                        onClick={handleExportCSV}
                        type="button"
                        style={{
                            padding: "5px 10px"
                        }}
                    />

                </div>
            </div>


            <div className="Filters-Section">
                <Accordion allowZeroExpanded className="accordion">
                    <AccordionItem>
                        <AccordionItemHeading>
                            <AccordionItemButton>Filters</AccordionItemButton>
                        </AccordionItemHeading>
                        <AccordionItemPanel>
                            <div className="filter-row-01">
                                <div className="filter-label">Customer Name</div>
                                <div className="filter-label">Email</div>
                                <div className="filter-label">Phone #</div>
                                <div className="filter-label">Status</div>
                            </div>
                            <div className="filter-row-02">
                                <InputField
                                    value={custName}
                                    name="custName"
                                    onChange={(e) =>
                                        handleFilterChange(e.target.value, "custName")
                                    }
                                    placeholder="Enter Customer Name"
                                />
                                <InputField
                                    value={email}
                                    name="email"
                                    onChange={(e) => handleFilterChange(e.target.value, "email")}
                                    placeholder="Enter Email Address"
                                />
                                <InputField
                                    value={phoneNo}
                                    name="phoneNo"
                                    onChange={(e) =>
                                        handleFilterChange(e.target.value, "phoneNo")
                                    }
                                    placeholder="Enter Phone Number"
                                />
                                <Dropdowncustom
                                    options={OrderStatusOptions}
                                    selected={selectedStatus}
                                    onChange={(value) => handleFilterChange(value, "ordStatus")}
                                    dropdownClass="custom-dropdown-tax"
                                    dropdownstyle={{ width: "256px" }}
                                    headerborder="var(--standered-border)"
                                    listmaxHeight="160px"
                                    headerheight="32px"
                                    headerBgColor="#FDFDFD"
                                    size={17}
                                />
                            </div>

                            <div className="filter-row-04">
                                {!filtersApplied ? (
                                    <button type="submit" onClick={handleFilters} className="apply_filter_btn">
                                        {filterLoading ? <div
                                            style={{ borderTop: "4px solid white" }}
                                            className="btn-loader-Publish"
                                        ></div> : "Apply Filter"}
                                    </button>
                                ) : (
                                    <>
                                        <CustomBtn
                                            label="Reset"
                                            withIcon={true}
                                            iconType="reset"
                                            className="ResetBtn-OrderPage"
                                            onClick={handleResetFilters}
                                            type="button"
                                        />
                                        <CustomBtn
                                            label="Apply Filters"
                                            withIcon={true}
                                            iconType="filter"
                                            className="FilterBtn-OrderPage"
                                            type="submit"
                                            style={{ backgroundColor: "green" }}
                                        />
                                    </>
                                )}
                            </div>
                        </AccordionItemPanel>
                    </AccordionItem>
                </Accordion>
            </div>

            {/* {loading && (
        <div className="backdrop">
          <MainLoader />
        </div>
      )} */}

            <div className="Orders-Table-Data">
                <div>
                    <DataTable
                        columns={CustomerColumns}
                        data={displayedData}
                        customStyles={customStyles}
                    />
                    <ElipticalPagenation
                        activePageIndex={currentPage}
                        totalPages={totalPages}
                        onPrevPage={handlePrevPage}
                        onNextPage={handleNextPage}
                        onPageChange={handlePageChange}
                    />
                </div>
            </div>

            <BottomToust
                showMessage={showMessage}
                message={toastMessage}
                handleCloseMessageModal={() => handleCloseMessageModal()}
            />

        </div>
    );
};

export default CartAbdList;